var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighlight1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 152,
    viewBox: "0 0 256 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Highlight_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.205 144.583C207.015 145.133 230.325 144.033 252.135 151.833C253.435 152.293 254.865 151.623 255.335 150.323C255.795 149.023 255.125 147.593 253.825 147.123C231.505 139.143 207.665 140.143 184.325 139.583C182.945 139.543 181.795 140.643 181.765 142.023C181.725 143.403 182.825 144.543 184.205 144.583Z",
    fill: "url(#paint0_linear_88_7349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.155 111.466C189.265 104.924 197.025 100.023 206.405 97.5936C207.745 97.2476 208.545 95.8826 208.205 94.5466C207.855 93.2106 206.485 92.4076 205.155 92.7536C194.955 95.3936 186.505 100.676 178.775 107.785C177.755 108.719 177.685 110.302 178.625 111.318C179.555 112.333 181.145 112.4 182.155 111.466Z",
    fill: "url(#paint1_linear_88_7349)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.375 40.0426C165.635 28.8676 172.055 20.1256 181.895 13.8126C183.055 13.0676 183.395 11.5196 182.645 10.3586C181.905 9.1976 180.355 8.85958 179.195 9.60458C168.305 16.5946 161.185 26.2686 157.575 38.6416C157.185 39.9656 157.955 41.3556 159.275 41.7416C160.605 42.1286 161.995 41.3666 162.375 40.0426Z",
    fill: "url(#paint2_linear_88_7349)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0249 24.8766C48.0849 27.1596 46.3449 29.6196 44.8649 32.2386C44.2049 33.4046 43.0449 35.8826 42.8649 38.0076C42.6649 40.2716 43.4348 42.1816 45.4148 43.1876C48.0448 44.5216 50.1449 44.3826 51.7649 43.5756C53.3249 42.8006 54.5448 41.2776 55.3148 39.2356C56.7848 35.3326 56.5648 29.3676 55.7948 25.9636C57.8648 23.8276 60.1348 21.8906 62.5648 20.1686C80.6648 7.34356 107.215 12.0726 127.645 31.2486C134.795 37.9626 138.235 52.0626 140.025 67.2756C142.815 90.9626 141.225 117.419 141.005 125.17C140.955 127.084 141.135 128.22 141.235 128.447C141.705 129.563 142.535 129.853 143.115 129.963C143.955 130.113 144.625 129.953 145.165 129.673C145.895 129.289 146.495 128.613 146.775 127.57C146.925 126.994 146.965 126.192 146.945 125.337C146.925 124.744 146.805 124.096 146.925 123.671C147.705 120.949 148.645 118.291 149.565 115.614C152.635 106.615 156.605 98.1816 161.015 89.7586C175.025 62.9946 188.575 34.7156 211.545 14.3246C212.575 13.4096 212.675 11.8276 211.755 10.7956C210.845 9.76358 209.265 9.66955 208.225 10.5856C184.795 31.3796 170.875 60.1456 156.585 87.4396C152.835 94.6046 149.395 101.78 146.535 109.285C146.825 96.0086 146.715 77.6316 144.285 61.3716C142.125 46.9106 138.015 34.1306 131.065 27.6036C108.685 6.59656 79.4948 2.03958 59.6748 16.0896C57.5548 17.5936 55.5349 19.2476 53.6549 21.0416C43.2849 2.31661 21.0848 -5.18844 1.46484 3.76756C0.204836 4.34056 -0.345154 5.82457 0.224846 7.07957C0.804846 8.33457 2.28479 8.8886 3.54479 8.3156C21.2248 0.245596 41.2749 7.44757 50.0249 24.8766ZM51.4748 31.1456C50.6648 32.2896 49.9148 33.4756 49.2148 34.7016C48.8448 35.3596 48.2048 36.6246 47.9348 37.8626C47.8748 38.1526 47.8649 38.6066 47.8649 38.8166C48.5549 39.1566 49.0948 39.3206 49.5348 39.0996C50.0848 38.8276 50.3649 38.1876 50.6349 37.4726C51.3149 35.6786 51.5348 33.3006 51.4748 31.1456Z",
    fill: "url(#paint3_linear_88_7349)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_7349",
    x1: 181.764,
    y1: 139.582,
    x2: 195.098,
    y2: 174.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_88_7349",
    x1: 177.962,
    y1: 92.6732,
    x2: 207.555,
    y2: 113.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_88_7349",
    x1: 157.474,
    y1: 9.20892,
    x2: 190.414,
    y2: 20.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_88_7349",
    x1: 0,
    y1: 0,
    x2: 200.895,
    y2: 145.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight1);
export default __webpack_public_path__ + "static/media/Highlight_1.d424b2e7accd0a526e7ffcbcdc30ae3d.svg";
export { ForwardRef as ReactComponent };